import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import React, { Fragment, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ImageViewer from "react-simple-image-viewer";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import { IMAGE_QUALITY } from "../../utils/utils";
import "./HotelImageComponent.css";
import { useSelector } from "react-redux";

const HotelImageComponent = ({ hotelImages, name }) => {
  const [viewImage, setViewImage] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const { hotelData } = useSelector((state) => state.hotelInfo);
  
  const handleImage = (id) => {
    setViewImage(true);
    setCurrentIndex(id);
    fireGtmEvent("hotel_image_expanded");
  };

  return (
    <div className="hotelImageComponent" id="hotelImageDesktop">
      {/* {hotelImages?.length > 3 && !viewImage && (
        <p onClick={() => setViewImage(true)}>view more </p>
      )} */}

      {hotelData?.logo !== "" &&
        hotelData?.logo !== null &&
        hotelData?.logo &&
        (hotelData?.id === 529 ||
          hotelData?.chainName === "beacon" ||
          hotelData?.chainName === "zinc" ||
          hotelData?.chainName === "fern" ||
          hotelData?.id === 2825) && (
          <div
            // className={`landingPage__logo ${
            //   hotelData?.id === 529 ||
            //   hotelData?.chainName === "beacon" ||
            //   hotelData?.chainName === "zinc" ||
            //   hotelData?.id === 2825
            //     ? "special-logo"
            //     : ""
            // }`}
            className={`landingPage__logo ${
              hotelData?.chainName === "zinc" || hotelData?.id === 529
                ? "zinc-logo"
                : hotelData?.id === 2825 || hotelData?.chainName === "beacon" || hotelData?.chainName === "fern"
                ? "special-logo"
                : ""
            }`}
          >
            <img
              src={hotelData?.logo}
              alt={name + " logo image"}
              width={"60"}
              height={"60"}
              onClick={window?.HotelzifySDK?.toggle}
            />
          </div>
        )}
      {hotelImages?.length > 3 && !viewImage && (
        <p
          onClick={() => setViewImage(true)}
          className={
            hotelData?.chainName === "zinc" ||
            hotelData?.chainName === "beacon" ||
            hotelData?.chainName === "fern" ||
            hotelData?.id === 529 ||
            hotelData?.id === 2825
              ? "zinc-view-more"
              : "default-view-more"
          }
        >
          view more
        </p>
      )}
      {hotelImages?.length <= 2 && (
        <Fragment>
          {hotelImages[0]?.cdnImageUrl !== "" && (
            <div className="bigImage">
              <LazyLoadImage
                src={
                  hotelImages[0]?.cdnImageUrl +
                  `?tr=w-600,h-500,q-${IMAGE_QUALITY},fo-auto`
                }
                alt={name + " stay images"}
                onClick={() => handleImage(0)}
              />
            </div>
          )}
          {hotelImages[1] && hotelImages[1]?.cdnImageUrl !== "" && (
            <div className="bigImage">
              <LazyLoadImage
                src={
                  hotelImages[1]?.cdnImageUrl +
                  `?tr=w-600,h-500,q-${IMAGE_QUALITY},fo-auto`
                }
                alt={name + " stay images"}
                onClick={() => handleImage(1)}
              />
            </div>
          )}
        </Fragment>
      )}
      {hotelImages?.length >= 3 && (
        <Fragment>
          <div className="bigImage">
            <LazyLoadImage
              src={
                hotelImages[0]?.cdnImageUrl +
                `?tr=w-600,h-500,q-${IMAGE_QUALITY},fo-auto`
              }
              alt={name + " stay images"}
              onClick={() => handleImage(0)}
            />
          </div>
          <div className="smallImages">
            <div className="smallImage">
              <LazyLoadImage
                src={
                  hotelImages[1]?.cdnImageUrl +
                  `?tr=w-600,h-300,q-${IMAGE_QUALITY},fo-auto`
                }
                alt={name + " stay images"}
                onClick={() => handleImage(1)}
              />
            </div>
            <div className="smallImage">
              <LazyLoadImage
                src={
                  hotelImages[2]?.cdnImageUrl +
                  `?tr=w-600,h-300,q-${IMAGE_QUALITY},fo-auto`
                }
                alt={name + " stay images"}
                onClick={() => handleImage(2)}
              />
            </div>
          </div>
          {hotelImages?.length >= 5 && (
            <>
              <div className="smallImages">
                <div className="smallImage">
                  <LazyLoadImage
                    src={
                      hotelImages[3]?.cdnImageUrl +
                      `?tr=w-600,h-300,q-${IMAGE_QUALITY},fo-auto`
                    }
                    alt={name + " stay images"}
                    onClick={() => handleImage(3)}
                  />
                </div>
                <div className="smallImage">
                  <LazyLoadImage
                    src={
                      hotelImages[4]?.cdnImageUrl +
                      `?tr=w-600,h-300,q-${IMAGE_QUALITY},fo-auto`
                    }
                    alt={name + " stay images"}
                    onClick={() => handleImage(4)}
                  />
                </div>
              </div>
            </>
          )}
        </Fragment>
      )}
      {viewImage && (
        <ImageViewer
          src={hotelImages?.map((img) => {
            return img.cdnImageUrl;
            // return img.cdnImageUrl + "?tr=w-auto-720,ar-1-1,h-600,q-80";
          })}
          currentIndex={currentIndex}
          disableScroll={false}
          closeOnClickOutside={true}
          onClose={setViewImage}
        />
      )}
    </div>
  );
};

export default HotelImageComponent;
